import { useNavigate } from 'react-router-dom';

const MyInvoices = () => {
  const navigate = useNavigate();
  return (
    <div>Liste over fakturaer<p><button className="btn btn-primary" onClick={() => navigate(-1)}>Tilbake</button></p></div>
  )
}

export default MyInvoices